import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
var defaultHosts = {
  qa: 'https://qa-api.weddings.xogrp.com',
  production: 'https://api.weddings.xogrp.com'
};
var invalidEnv = function invalidEnv(env) {
  /* eslint-disable no-console */
  console.error("\nSpecified 'env' value: ".concat(_JSON$stringify(env), " is invalid. Please use \"qa\" or \"production\""));

  /* Fallback to qa if ENV is invalid */
  return defaultHosts.qa;
};
var configureClient = function configureClient(_ref) {
  var _ref$env = _ref.env,
    env = _ref$env === void 0 ? function () {
      if (process.env.UNION_WEDDING_API_ENV) {
        if (process.env.UNION_WEDDING_API_ENV !== "qa" && process.env.UNION_WEDDING_API_ENV !== "production") {
          throw new Error("Expected UNION_WEDDING_API_ENV to be 'qa' or 'production'.");
        }
        console.warn('Using UNION_WEDDING_API_ENV could result in a misconfigured environment. It is best that you use UNION_DEPLOYMENT_ENV for all your Union services integrations.');
        return process.env.UNION_WEDDING_API_ENV;
      }
      if (process.env.UNION_DEPLOYMENT_ENV) {
        if (process.env.UNION_DEPLOYMENT_ENV !== "qa" && process.env.UNION_DEPLOYMENT_ENV !== "production") {
          throw new Error("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'.");
        }
        return process.env.UNION_DEPLOYMENT_ENV;
      }
      if (false) {
        console.warn("Expected UNION_DEPLOYMENT_ENV to be 'qa' or 'production'. NODE_ENV fallback will be removed in a future version.");
        return process.env.NODE_ENV === 'production' ? 'production' : 'qa';
      }
      throw new Error("Expected UNION_DEPLOYMENT_ENV to be either 'qa' or 'production'.");
    }() : _ref$env,
    _ref$host = _ref.host,
    host = _ref$host === void 0 ? process.env.UNION_WEDDING_API_HOST || defaultHosts[env] || invalidEnv(env) : _ref$host,
    _ref$apiKey = _ref.apiKey,
    apiKey = _ref$apiKey === void 0 ? process.env.UNION_WEDDING_API_KEY : _ref$apiKey;
  return {
    host: host,
    apiKey: apiKey
  };
};
export default configureClient;